import { render, staticRenderFns } from "./PopDepartamento2.vue?vue&type=template&id=7c1b0994&scoped=true"
import script from "./PopDepartamento2.vue?vue&type=script&lang=js"
export * from "./PopDepartamento2.vue?vue&type=script&lang=js"
import style0 from "./PopDepartamento2.vue?vue&type=style&index=0&id=7c1b0994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1b0994",
  null
  
)

export default component.exports